import { render, staticRenderFns } from "./promotions-detail.vue?vue&type=template&id=02bb7acf&scoped=true&"
import script from "./promotions-detail.vue?vue&type=script&lang=js&"
export * from "./promotions-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotions-detail.vue?vue&type=style&index=0&id=02bb7acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb7acf",
  null
  
)

export default component.exports